<div class="section" style="flex: 1; display: flex; flex-direction: column; width: 100%; height: 100%"
  data-cy="ar-debit-credit-reasons">
  <div class="section-header" data-cy="ar-debit-credit-reasons-header">
    <div class="section-header-title" data-cy="ar-debit-credit-reasons-title">{{ this.showDebitReasons ? 'Debit' :
      'Credit' }} Reasons</div>
  </div>
  @if (isLoading()) {
  <div class="debit-reason-dialog-loader" data-cy="ar-debit-credit-reasons-loader">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
  } @else {
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;"
    data-cy="ar-debit-credit-reasons-content">
    <div style="text-align: right" data-cy="ar-debit-credit-reasons-add-container">
      <button class="tdo-button tdo-save" style="margin-right: 12px;" (click)="addRow()"
        data-cy="ar-debit-credit-reasons-add-btn">Add Reason</button>
    </div>
    <div
      style="display: flex; flex-direction: column; height: 555px; overflow-y: scroll; overflow-x:hidden; margin-top: 10px"
      data-cy="ar-debit-credit-reasons-table-container">
      <table mat-table [dataSource]="creditDebitReasonsTable" data-cy="ar-debit-credit-reasons-table">
        <ng-container matColumnDef="Reason">
          <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="ar-debit-credit-reasons-header-reason">
            Reason</th>
          <td mat-cell *matCellDef="let element" data-cy="ar-debit-credit-reasons-cell-reason">
            <div class="input-container-height" data-cy="ar-debit-credit-reasons-reason-container">
              <mat-form-field style="width:100%" data-cy="ar-debit-credit-reasons-reason-field">
                <mat-label data-cy="ar-debit-credit-reasons-reason-label">Reason</mat-label>
                <input matInput placeholder="Reason" [(ngModel)]="element.Reason" (ngModelChange)="updateCanSave()"
                  autocomplete="off" style="width: 100%" data-cy="ar-debit-credit-reasons-reason-input" />
              </mat-form-field>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="enumCreditDebitTypeID">
          <th mat-header-cell *matHeaderCellDef class="matCellyHeader"
            data-cy="ar-debit-credit-reasons-header-standard">Standard Reason</th>
          <td mat-cell *matCellDef="let element" data-cy="ar-debit-credit-reasons-cell-standard">
            @if (showCreditReasons) {
            <div class="input-container-height" data-cy="ar-debit-credit-reasons-credit-container">
              <mat-form-field style="width:100%;" data-cy="ar-debit-credit-reasons-credit-field">
                <mat-label data-cy="ar-debit-credit-reasons-credit-label">Standard Reason</mat-label>
                <mat-select [(ngModel)]="element.enumARReasonCreditAdjustmentID" hideSingleSelectionIndicator
                  (ngModelChange)="updateCanSave()" data-cy="ar-debit-credit-reasons-credit-select">
                  @for (r of enumAdjustmentReasons; track r) {
                  <mat-option [value]="r.ValidValueItemId"
                    data-cy="ar-debit-credit-reasons-credit-option-{{r.ValidValueItemId}}">
                    {{ r.ItemDisplayValue }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @else if (showDebitReasons) {
            <div class="input-container-height" data-cy="ar-debit-credit-reasons-debit-container">
              <mat-form-field style="width:100%;" data-cy="ar-debit-credit-reasons-debit-field">
                <mat-label data-cy="ar-debit-credit-reasons-debit-label">Standard Reason</mat-label>
                <mat-select [(ngModel)]="element.enumARReasonDebitAdjustmentID" hideSingleSelectionIndicator
                  (ngModelChange)="updateCanSave()" data-cy="ar-debit-credit-reasons-debit-select">
                  @for (r of enumAdjustmentReasons; track r) {
                  <mat-option [value]="r.ValidValueItemId"
                    data-cy="ar-debit-credit-reasons-debit-option-{{r.ValidValueItemId}}">
                    {{ r.ItemDisplayValue }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="isExcludeFromAdjRec">
          <th mat-header-cell *matHeaderCellDef class="matCellyHeader"
            data-cy="ar-debit-credit-reasons-header-exclude-adj-rec">{{ excludeFromAdjustedLabel }}</th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"
            data-cy="ar-debit-credit-reasons-cell-exclude-adj-rec">
            <mat-checkbox [(ngModel)]="element.isExcludeFromAdjRec" (ngModelChange)="updateCanSave()"
              [aria-label]="excludeFromAdjustedLabel + ': ' + (element.Reason || 'new reason')"
              data-cy="ar-debit-credit-reasons-exclude-adj-rec-checkbox"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="CreditDebitReasonID">
          <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width:30px"
            data-cy="ar-debit-credit-reasons-header-actions"></th>
          <td mat-cell *matCellDef="let element" style="text-align: right; padding-right: 0px !important;"
            data-cy="ar-debit-credit-reasons-cell-actions">
            <button mat-icon-button color="red" aria-label="Remove Reason"
              (click)="removeReason(element.CreditDebitReasonID)" matTooltip="Remove Reason"
              data-cy="ar-debit-credit-reasons-remove-btn">
              <lucide-icon name="x" [size]="20" data-cy="ar-debit-credit-reasons-remove-icon"></lucide-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row class="top-header-row" *matHeaderRowDef="columnsToDisplayTopRow;  sticky: true"
          data-cy="ar-debit-credit-reasons-header-row"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplayTopRow;" class="first-row-in-group"
          data-cy="ar-debit-credit-reasons-row"></tr>
      </table>
    </div>
    <div style="text-align: right" data-cy="ar-debit-credit-reasons-footer">
      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel()"
        data-cy="ar-debit-credit-reasons-close-btn">Close</button>
      <button [disabled]="!canSaveValue" class="tdo-button tdo-save" (click)="saveChanges()"
        data-cy="ar-debit-credit-reasons-save-btn">Save</button>
    </div>
  </div>
  }
</div>
